module.exports = __webpack_public_path__ + "fonts/iconfont.9368cedd.ttf";